import { action, ActionType } from "typesafe-actions";

import { IError } from "../../../../../../../../../../redux/actions/errorHandlingAction";
import { SearchResults } from "../../../../../../../../../../types/search/search-results.interface";

import { PositionCategory } from "../../types/flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.interface";

export enum FlyerDetailPageFormPositionCategoriesActions {
  ClearCategoryResults = "FlyerDetailPagePositionCategories/ClearCategoryResults",

  SearchCategory = "FlyerDetailPagePositionCategories/SearchCategory",
  SearchCategoryFailure = "FlyerDetailPagePositionCategories/SearchCategoryFailure",
  SearchCategorySuccess = "FlyerDetailPagePositionCategories/SearchCategorySuccess",
}

export const clearCategoryResults = () =>
  action(FlyerDetailPageFormPositionCategoriesActions.ClearCategoryResults);

export const searchCategory = (searchText: string) =>
  action(FlyerDetailPageFormPositionCategoriesActions.SearchCategory, searchText);
export const searchCategoryFailure = (error: IError) =>
  action(FlyerDetailPageFormPositionCategoriesActions.SearchCategoryFailure, error);
export const searchCategorySuccess = (results: SearchResults<PositionCategory>) =>
  action(FlyerDetailPageFormPositionCategoriesActions.SearchCategorySuccess, results);

const actionCreators = {
  clearCategoryResults,

  searchCategory,
  searchCategoryFailure,
  searchCategorySuccess,
};

export type FlyerDetailPageFormPositionCategoriesActionType = ActionType<typeof actionCreators>;
